import type { CSSProperties } from "react";

type BlurredMediaProps = {
  src: string;
  alt: string;
  caption?: string;
  /** Tailwind blur class, e.g. blur-md, blur-lg, blur-xl */
  blurClass?: string;
  className?: string;
  objectPosition?: CSSProperties["objectPosition"];
  aspectClass?: string;
};

export function BlurredMedia({
  src,
  alt,
  caption,
  blurClass = "blur-md",
  className = "",
  objectPosition = "50% 20%",
  aspectClass = "aspect-[4/5]",
}: BlurredMediaProps) {
  return (
    <figure
      className={`group relative overflow-hidden rounded-lg border border-border-soft ${aspectClass} ${className}`.trim()}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`h-full w-full scale-[1.08] object-cover transition-[filter,transform] duration-500 group-hover:scale-110 ${blurClass}`}
        style={{ objectPosition }}
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-t from-canvas via-canvas/35 to-transparent"
        aria-hidden
      />
      <IfCaption caption={caption} />
    </figure>
  );
}

function IfCaption({ caption }: { caption?: string }) {
  if (!caption) return null;
  return (
    <figcaption className="absolute inset-x-0 bottom-0 p-4 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-ink-secondary">
      {caption}
    </figcaption>
  );
}
